import {
    Box,
    Center,
    Divider,
    Heading,
    HStack,
    Image,
    Link,
    SimpleGrid,
    Text,
    VStack
} from "@chakra-ui/react";
import PartnersImage from "../images/partners.webp";
import PapaCro from "../images/papacro.webp";
import CroDoo from "../images/crodoo.webp";
import He3 from "../images/he3.webp";

const PartnersView: React.FC = () => {
    return (
        <>
            <HStack pt={8} minW={360} maxW={"xl"} margin={"auto"}>
                <Divider borderWidth={2} />
                <Heading w={'100%'} textColor={'rgb(218, 165, 32)'} textAlign={"center"} fontFamily={"Sedgwick Ave Display"} fontSize={'4xl'}>PARTNERS</Heading>
                <Divider borderWidth={2} />
            </HStack>
            <Center>
                <Image src={PartnersImage} />
            </Center>
            <SimpleGrid
                columns={{ base: 1, md: 3 }}
                spacing={{ base: 4, md: 8 }}
                my={{ base: 4, md: 8 }}
                mx={"auto"}
                maxW={"6xl"}
                textColor={'rgb(218, 165, 32)'}
                fontWeight={700}
                fontSize={'xl'}
                fontFamily={"Sedgwick Ave Display"}
            >
                <Link isExternal href="https://papa-cro.netlify.app">
                    <VStack>
                        <Box
                            p={4}
                            rounded={"xl"}
                            boxShadow={"md"}
                            bg={"rgba(23, 23, 23, 0.5)"}
                            border={'2px solid rgb(218, 165, 32)'}
                        >
                            <Image objectFit={'cover'} boxSize={'252px'} src={PapaCro} />
                        </Box>
                        <Text>PAPACRO</Text>
                    </VStack>
                </Link>

                <Link isExternal href="https://crodoonft.com">
                    <VStack>
                        <Box
                            p={4}
                            rounded={"xl"}
                            boxShadow={"md"}
                            bg={"rgba(23, 23, 23, 0.5)"}
                            border={'2px solid rgb(218, 165, 32)'}
                        >
                            <Image objectFit={'cover'} boxSize={'252px'} src={CroDoo} />
                        </Box>
                        <Text>CRODOO NFT</Text>
                    </VStack>
                </Link>

                <Link isExternal href="https://moonmininghe3.com">
                    <VStack>
                        <Box
                            p={4}
                            rounded={"xl"}
                            boxShadow={"md"}
                            bg={"rgba(23, 23, 23, 0.5)"}
                            border={'2px solid rgb(218, 165, 32)'}
                        >
                            <Image objectFit={'cover'} boxSize={'252px'} src={He3} />
                        </Box>
                        <Text>MOONMININGHE3</Text>
                    </VStack>
                </Link>
            </SimpleGrid>
        </>
    );
};

export default PartnersView;
